import { configureStore } from "@reduxjs/toolkit";
import modalReducer from '../data/modalSlice';

const store = configureStore({
  reducer: {
    modal: modalReducer,
  }
});

export default store;
